import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { RouterService } from 'src/app/services/router/router.service'
import { UserService } from 'src/app/services/user/user.service'

@Injectable({
  providedIn: 'root',
})
export class FriendProfileGuard implements CanActivate {
  constructor(private userService: UserService, private routerService: RouterService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const { uniqueName } = route.params
    if (this.userService.user.profile.uniqueName === uniqueName) {
      this.routerService.navigate('profile')
      return false
    }
    return true
  }

  private get isUserDataSetProperly(): boolean {
    return this.userService.user.id > 0
  }
}
